export const DEFAULT_NETWORK = 'ethereum';
export const NETWORKS = ['ethereum', 'gnosis'];

export const PROTOCOL_COLORS: Record<string, string> = {
  sparklend: '#ffab55',
  morpho: '#2470FF',
  aave: '#9896FF',
  sky: '#7A77FF',
  fluid: '#70A3F3',
  ethena: '#88B4F5',
  PSM3: '#18daf0',
  superstate: '#1f6f4f',
  maple: '#fc813b',
  centrifuge: '#1253FF',
  blackrock: '#FFFFFF',
  curve: '#a8ff4d'
};

export const NETWORK_COLORS: Record<string, string> = {
  ethereum: '#B48EF0',
  base: '#0052FF',
  arbitrum: '#12AAFF',
  optimism: '#ff0420',
  unichain: '#f50db4'
};
